import Vue from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'
import qs from 'qs'
import router from '@/router'
import {
  isArray
} from '@/utils/validate'

let loadingInstance
let debounce = ['doEdit', 'accidentServiceCorp', 'aseByArea'];
let invalidCode = ['402', '407', '406','410'];
let noPermissionCode = '401',requestTimeout = 600000, successCode = ['1000', '2000', 200, 2000],signedInCode = '6666',tokenTableName = 'yingji-admin-' + new Date().getFullYear(),accessToken = 'accessToken'

/**
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const handleCode = (code, msg) => {
  if (invalidCode.includes(code)) {
    console.log(code)
    if(code == 410) {
      localStorage.clear();
      // alert(localStorage.getItem('token'))
      // if (this.$env.inDjxApp){
        // if (this.$env.inAndroid){
        //   try {
        //     JSInterface.toLogOut()
        //   } catch (error) {
        //     console.log(error)
        //   }
        // }else if (this.$env.inIos) {
        //   try {
        //     window.webkit.messageHandlers.toLogOut.postMessage(null);
        //   } catch (error) {
        //     console.log(error)
        //   }
         
        // }
      // }
      router.push({
        path: '/login'
      }).catch(() => {})
      return
    }
   
    Vue.prototype.$message(msg || `后端接口${code}异常`, 'error')
  } else if (code === noPermissionCode) {
    router.push({
      path: '/401'
    }).catch(() => {})
  } else if (code === signedInCode) {
    Vue.prototype.$message(msg || `后端接口${code}异常`, 'warning')
  } else {
    Vue.prototype.$message(msg || `后端接口${code}异常`, 'error')
  }
}

const instance = axios.create({
  timeout: requestTimeout,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
})

instance.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] =  localStorage.getItem('token') 
    // Cookies.get(tokenTableName) ||
    if (
      config.data &&
      config.headers['Content-Type'] ===
      'application/x-www-form-urlencoded;charset=UTF-8'
    ) {
      config.data = qs.stringify(config.data)
    }
    if (!config.noLoading && !debounce.some((item) => config.url.includes(item))) {
      loadingInstance = Vue.prototype.$loading(3)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    if (loadingInstance) loadingInstance.close()
    const {
      data,
      config,
      headers
    } = response
    const {
      code,
      msg
    } = data
    // 操作正常Code数组
    const codeVerificationArray = isArray(successCode) ? [...successCode] : [...[successCode]]
    // 是否操作正常
    if (!code) {
      // 判断 如果无数据  获取 headers数据
      return {
        headers,
        data
      }
    } else if (codeVerificationArray.includes(code)) {
      return data
    } else {
      handleCode(code, msg)
      return Promise.reject(
        'yingji-admin请求异常拦截:' +
        JSON.stringify({
          url: config.url,
          code,
          msg
        }) || 'Error'
      )
    }
  },
  (error) => {
    if (loadingInstance) loadingInstance.close()
    const {
      response,
      message
    } = error
    if (error.response && error.response.data) {
      const {
        status,
        data
      } = response
      handleCode(status, data.msg || message)
      return Promise.reject(error)
    } else {
      let {
        message
      } = error
      if (message === 'Network Error') {
        message = '后端接口连接异常'
      }
      if (message.includes('timeout')) {
        message = '后端接口请求超时'
      }

      if (message.includes('Request failed with status code')) {
        const code = message.substr(message.length - 3)
        message = '后端接口' + code + '异常'
      }
      Vue.prototype.$message(message || `后端接口未知异常`, 'error')
      return Promise.reject(error)
    }
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/utils/request.js